import styles from './Loader.module.css';

// From Jonas Schmedtmann
function Loader() {
  return (
    <p className={styles.loader}>Loading...</p>
  )
}

export default Loader;
